// extracted by mini-css-extract-plugin
export default {"select":"RestaurantSelect_select__-tBmZ"};